const htmlContent = `
<div id="markdown">
<h1 id="azure">Azure</h1>
<p>Dies ist der Azure-Teil von
<a href="/terraform-statefile">diesem Beitrag</a>  </p>
<p>Bitte lesen Sie die README aus meinem Git-Repository:  </p>
<p><a href="https://github.com/ludwigprager/azure-terraform-base/blob/master/README.md"><img src="https://www.celp.de/img/md/atp.png" alt="azure-terraform-base repository" title="azure-terraform-base repository on github"></a></p>

</div>
`;
export default htmlContent
